'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _addClass = require('../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _debounce = require('../helpers/util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _toggleClass = require('../helpers/dom/toggle-class');

var _toggleClass2 = _interopRequireDefault(_toggleClass);

var _offset = require('../helpers/dom/offset');

var _offset2 = _interopRequireDefault(_offset);

var _outerHeight = require('../helpers/dom/outer-height');

var _outerHeight2 = _interopRequireDefault(_outerHeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Toast
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Show or hide a toast notification. toast appears at the top of the panel or below a header at the top of the panel.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * to anchor the toast below a header
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Toast(el, {elHeader:[DOM OBJECT] });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * to anchor the toast at the top of a panel
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Toast(el);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/toast.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Toast = function (_BaseComponent) {
  _inherits(Toast, _BaseComponent);

  /**
   * Toast Constructor
   * @param {Element} el          root element to attach the toast
   * @param {Object} [params={}]  toast parameters see defaults
   */
  function Toast(el) {
    var _ret;

    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Toast);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    if (!el) return _ret = _this, _possibleConstructorReturn(_this, _ret);

    // get the position type of the container. if it's fixed you have to handle the toast differently
    _this._elPosition = window.getComputedStyle(_this.el, null).getPropertyValue('position');
    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    _this._createTypes();
    _this._isActive = false;
    return _this;
  }

  /**
   * Add Toast window event listners
   */


  Toast.prototype._addWindowListeners = function _addWindowListeners() {

    // listen to the scroll event, manage to visiblity / position on the screen
    window.addEventListener('scroll', this._onScrollBound);

    // resize the toast as the screen resizes
    window.addEventListener('resize', this._doResizeBound);
  };

  /**
   * Add Toast event listners
   */


  Toast.prototype._addEventListeners = function _addEventListeners() {

    // if the position is fixed then this is probably the fixed header with the resize
    if (window.getComputedStyle(this.el, null).getPropertyValue('position') === 'fixed') {
      this.el.addEventListener('transitionend', this._fixedHeaderTransitionBound);
    }
    this._dom.panel.actions.el.addEventListener('click', this._doActionBound);
    this._dom.root.addEventListener('touchstart', this._touchStart.bind(this));
    this._dom.root.addEventListener('touchend', this._touchEnd.bind(this));
  };

  /**
   * attach the toast to the DOM
   */


  Toast.prototype._attachToast = function _attachToast() {
    this.el.insertBefore(this._dom.root, this.el.firstChild);
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  Toast.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._fixedHeaderTransitionBound = this._fixedHeaderTansition.bind(this);
    this._onScrollBound = this._onScroll.bind(this);
    this._doActionBound = this._doAction.bind(this);
    this._doResizeBound = (0, _debounce2.default)(this._resize.bind(this), 100);
    this._onHidePanelBound = this._onHidePanel.bind(this);
    this._onTimerDoneBound = this._onTimerDone.bind(this);
  };

  /**
   * Set's up references
   * @param  {Element} el base DOM element
   */


  Toast.prototype._cacheElements = function _cacheElements(el) {

    // set up a convience object to hold all the references to the dom elements;
    this._dom = {
      root: '',
      panel: {
        root: '',
        icon: {
          root: '',
          el: ''
        },
        content: {
          root: '',
          title: '',
          details: ''
        },
        actions: {
          root: '',
          el: ''
        },
        timer: {
          root: ''
        }
      }
    };
    this.el = el;

    // capture the creation time to set a unique ID on the toast messages that may be used by accessibility features if needed for an alertdialog
    var _toastTime = new Date().getTime();

    // set id's for alertdialogs
    this._ariaLabelledBy = 'spark-toast--title-' + _toastTime.toString(16);
    this._arialDescribedBy = 'spark-toast--details-' + _toastTime.toString(16);

    // create the dom components
    this._dom.root = document.createElement('div');
    this._dom.toast = document.createElement('div');
    this._dom.panel.root = document.createElement('div');
    this._dom.panel.icon.root = document.createElement('div');
    this._dom.panel.icon.el = document.createElement('i');
    this._dom.panel.icon.root.setAttribute('aria-hidden', true);
    this._dom.panel.content.root = document.createElement('div');
    this._dom.panel.content.title = document.createElement('h4');
    this._dom.panel.content.title.setAttribute('role', 'presentation');
    this._dom.panel.content.title.setAttribute('id', this._ariaLabelledBy);
    this._dom.panel.content.details = document.createElement('p');
    this._dom.panel.content.details.setAttribute('id', this._arialDescribedBy);
    this._dom.panel.actions.root = document.createElement('div');
    this._dom.panel.actions.el = document.createElement('button');
    this._dom.panel.actions.el.setAttribute('role', 'button');
    this._dom.panel.timer.root = document.createElement('div');
    (0, _addClass2.default)(this._dom.root, 'spark-toast-root');
    (0, _addClass2.default)(this._dom.toast, 'spark-toast');
    (0, _addClass2.default)(this._dom.panel.root, 'spark-toast__panel');
    (0, _addClass2.default)(this._dom.panel.icon.root, 'spark-toast__icon');
    (0, _addClass2.default)(this._dom.panel.content.root, 'spark-toast__content');
    (0, _addClass2.default)(this._dom.panel.content.title, '');
    (0, _addClass2.default)(this._dom.panel.content.details, '');
    (0, _addClass2.default)(this._dom.panel.actions.root, 'spark-toast__actions');
    (0, _addClass2.default)(this._dom.panel.content.title, 'spark-toast__heading');
    (0, _addClass2.default)(this._dom.panel.content.details, 'spark-toast__details');
    (0, _addClass2.default)(this._dom.panel.timer.root, 'spark-toast__timer');
    this._dom.panel.icon.root.appendChild(this._dom.panel.icon.el);
    this._dom.panel.content.root.appendChild(this._dom.panel.content.title);
    this._dom.panel.content.root.appendChild(this._dom.panel.content.details);
    this._dom.panel.actions.root.appendChild(this._dom.panel.actions.el);
    this._dom.panel.root.appendChild(this._dom.panel.icon.root);
    this._dom.panel.root.appendChild(this._dom.panel.content.root);
    this._dom.panel.root.appendChild(this._dom.panel.actions.root);
    this._dom.panel.root.appendChild(this._dom.panel.timer.root);
    this._dom.toast.appendChild(this._dom.panel.root);
    this._dom.root.appendChild(this._dom.toast);
  };

  /**
   * method decides if the toast should be fixed or position absolute, makes adjustments as need to position of the toast
   *
   */


  Toast.prototype._checkFixed = function _checkFixed() {

    // if the parent is not fixed (currently only use case is fixed header) then position toast correctly
    if (this._elPosition !== 'fixed') {
      var scrollTop = window.pageYOffset !== undefined ? window.pageYOffset : window.document.body.scrollTop;
      var scrollLeft = window.pageXOffset !== undefined ? window.pageXOffset : window.document.body.scrollLeft;

      // if the starting position less than the scroll top value, then the toast still needs to display so set the fixed class
      if (this._startTop < scrollTop) {
        (0, _toggleClass2.default)(this._dom.toast, 'spark-toast--fixed', true);
        this._dom.toast.style['top'] = 0;
        this._dom.toast.style['left'] = (0, _offset2.default)(this.el, false).left - scrollLeft + 'px';
      } else {

        // set notification is positioned absolute
        (0, _toggleClass2.default)(this._dom.toast, 'spark-toast--fixed', false);

        // if it should appear below a header element.
        if (this.elHeader) {
          this._dom.toast.style['left'] = '-' + Math.floor((0, _offset2.default)(this.elHeader, false).left - (0, _offset2.default)(this.el, false).left) + 'px';
          this._dom.toast.style['top'] = (0, _outerHeight2.default)(this.elHeader) + 'px';
        } else {
          this._dom.toast.style['left'] = 0;
          this._dom.toast.style['top'] = 0;
        }
      }
    } else {
      this._dom.toast.style['top'] = (0, _outerHeight2.default)(this.el) + 'px';
    }
  };

  /**
   * Creates a object that contains default classnames, allows for possible other defaults
   *
   */


  Toast.prototype._createTypes = function _createTypes() {
    this._toastTypes = {};
    this._toastTypes.positive = {
      className: 'spark-toast--positive'
    };
    this._toastTypes.neutral = {
      className: 'spark-toast--neutral'
    };
    this._toastTypes.warning = {
      className: 'spark-toast--warning'
    };
    this._toastTypes.error = {
      className: 'spark-toast--error'
    };
  };

  /**
   * Action is the generic method called from pressing the dismiss button. it's generic incase we open the flood gates and allow other actions in that location
   * @param  {MouseEvent} _event click
   */


  Toast.prototype._doAction = function _doAction(_event) {
    if (_event) {
      _event.stopImmediatePropagation();
    }

    // Custom on action call back disable due to accessibility concerns
    this.onAction = null;

    // trigger the timer done event to start the close animation
    if (typeof this.onAction === 'function') {
      this.onAction();
    }

    // user interacted with the Toast time,to hide it.
    this._onTimerDoneBound(_event);
  };

  /**
   * listen to fixed header transition then adjust the header of the toast notification
   * @param  {AnimationEvent} _event animationend
   */


  Toast.prototype._fixedHeaderTansition = function _fixedHeaderTansition() {
    this._dom.toast.style['top'] = (0, _outerHeight2.default)(this.el) + 'px';
  };

  /**
   * remove the toast from the DOM
   * @param  {AnimationEvent} _event animationend
   */


  Toast.prototype._onHidePanel = function _onHidePanel(_event) {
    if (_event) {
      _event.stopImmediatePropagation();
    }

    // set the toast to inactive
    this._isActive = false;

    // remove the show class
    (0, _removeClass2.default)(this._dom.panel.root, 'spark-toast--show');

    // remove the event listener, IE10 doesn't like the once:true option
    this._dom.panel.root.removeEventListener('animationend', this._onHidePanelBound);

    // remove toast from dom.
    this._dom.root.parentNode.removeChild(this._dom.root);

    // toast doesn't need to respond to window events, since it's not part of the DOM
    this._removeWindowListeners();

    // restore focus
    if (this._lastFocused !== null) {
      this._lastFocused.focus();
    }
    this._lastFocused = null;
  };

  /**
   * if the toast is in a fixed position make sure it stays relative to the element that its attached too.
   * even left / right.
   */


  Toast.prototype._onScroll = function _onScroll() {
    this._checkFixed();
  };

  /**
   * called fromt timer animation completion, triggers animation to hide toast
   * @param  {AnimationEvent} _event animationend event triggered from timer
   */


  Toast.prototype._onTimerDone = function _onTimerDone(_event) {
    if (_event) {
      _event.stopImmediatePropagation();
    }

    // remove the event listener, the {once:true} does not work in IE10 so we have to do it manually
    this._dom.panel.timer.root.removeEventListener('animationend', this._onTimerDoneBound);

    // clear out any animations;
    this._dom.panel.root.style['animation'] = '';

    // add listener to trigger Hiding the Panel
    this._dom.panel.root.addEventListener('animationend', this._onHidePanelBound);

    // quickly animate out the panel.
    this._dom.panel.root.style['animation'] = 'toast-animation-out .25s ease-out .2s 1 backwards';
    this._isActive = false;
  };

  /**
   * main public method, opens toast.
   * @param  {Object} options Toast options Object
   */


  Toast.prototype.open = function open(options) {

    // get the currently focussed element;
    this._setLastFocused();
    if (!this.el) return this;
    this._updateValues(options);

    // use the role alertsdialog since the toast is actionable
    if (this.actionIcon === '' && this.actionLabel === '') {

      // no action to be taken the role changes to alert
      this._dom.toast.removeAttribute('aria-labelledby');
      this._dom.toast.removeAttribute('aria-describedby');
      this._dom.toast.setAttribute('role', 'alert');
    } else {
      this._dom.toast.setAttribute('aria-labelledby', this._ariaLabelledBy);
      this._dom.toast.setAttribute('aria-describedby', this._arialDescribedBy);
      this._dom.toast.setAttribute('role', 'alertdialog');
    }
    this._dom.panel.content.title.innerHTML = this.title;
    this._dom.panel.content.details.innerHTML = this.details;
    this._dom.toast.className = 'spark-toast spark-toast--' + this.type;

    // if the parent is fixed add the toast fixed style to it;
    if (this._elPosition === 'fixed') {
      (0, _toggleClass2.default)(this._dom.toast, 'spark-toast--fixed', true);
    } else {
      (0, _toggleClass2.default)(this._dom.toast, 'spark-toast--fixed', false);

      // place the element under the header if necessary
      this._dom.toast.style['top'] = this.el.offsetTop + this.el.offsetHeight + 'px';
    }

    this._dom.panel.icon.el.className = 'spark-icon spark-icon--fill ' + this.icon;
    if (this.actionIcon !== '' && this.actionIcon) {
      if (this.actionLabel) {

        // add accessiblility attribute to so it reads like DISMISS BUTTON instead of just BUTTON
        this._dom.panel.actions.el.setAttribute('aria-label', this.actionLabel);
      }
      this._dom.panel.actions.el.className = 'spark-btn--icon spark-icon spark-icon--fill ' + this.actionIcon;
      this._dom.panel.actions.el.innerHTML = '';
    } else {
      this._dom.panel.actions.el.removeAttribute('aria-label');
      this._dom.panel.actions.el.className = 'spark-btn spark-btn--text';
      this._dom.panel.actions.el.innerHTML = this.actionLabel;
    }
    if (this._isActive === false) {

      // checks if a new event came it before the animation has finished on the previous toast notificaiton;
      if (this._dom.root.parentNode) {
        this._onHidePanel();
      }

      // add the window listeners
      this._addWindowListeners();

      // attach the toast to the element;
      this._attachToast();

      // gets the position of the parent this will allow us to decide if this should be handled be place under a fixed position header
      this._elPosition = window.getComputedStyle(this.el, null).getPropertyValue('position');

      // keep track of the current starting position, in this case header would scroll, but the message will be fixed so it is display on the screen
      if (this.elHeader) {
        this._startTop = (0, _outerHeight2.default)(this.elHeader) + (0, _offset2.default)(this.el, false).top;
      } else {
        this._startTop = (0, _offset2.default)(this.el, false).top;
      }

      // track the width of the parent, the toast content is positioned absolute so doesn't have a default widht;
      this._dom.toast.style['width'] = this.el.offsetWidth + 'px';

      // stop any panel animations;
      this._dom.panel.root.style['animation'] = '';

      // set the show panel animation;
      (0, _addClass2.default)(this._dom.panel.root, 'spark-toast--show');
    }

    // check if it the toast is fixed position or to absolute relative to an element
    this._checkFixed();

    // set the focus to the action button
    this._setFocus();

    // restarts timer
    this._startTimer();

    // track if the notification is still active
    this._isActive = true;
  };

  /**
   * remove / clean up Toast
   */


  Toast.prototype.remove = function remove() {
    this._onHidePanel();
    this.el.removeEventListener('transitionend', this._fixedHeaderTansitionBound);
    this._dom = undefined;
  };

  /**
   * removes window listeners
   */


  Toast.prototype._removeWindowListeners = function _removeWindowListeners() {
    window.removeEventListener('scroll', this._onScrollBound);
    window.removeEventListener('resize', this._doResizeBound);
  };

  /**
   * resizes toast message
   */


  Toast.prototype._resize = function _resize() {
    if (this._isActive === true) {
      this._dom.toast.style['width'] = this.el.offsetWidth + 'px';
    }
  };

  /**
   * sets the focus of the action button
   */


  Toast.prototype._setFocus = function _setFocus() {
    if (this.actionLabel !== '' || this.actionIcon !== '') {
      this._dom.panel.actions.el.focus();
    }
  };

  /**
   * set a reference to the last focused element
   */


  Toast.prototype._setLastFocused = function _setLastFocused() {
    this._lastFocused = document.activeElement;
    if (!this._lastFocused || this._lastFocused === document.body) {
      this._lastFocused = null;
    } else if (document.querySelector) {
      this._lastFocused = document.querySelector(":focus");
    }
  };

  /**
   * this is the call back
   * @param  {Object} _event [description]
   */


  Toast.prototype._startTimer = function _startTimer() {

    // stop all the timer animation
    this._dom.panel.timer.root.style['animation'] = '';

    // trigger reflow to clear animation;
    void this._dom.panel.timer.root.offsetWidth;

    // add timer done listener this will trigger the close animation
    this._dom.panel.timer.root.addEventListener('animationend', this._onTimerDoneBound);

    // restart animation using current duration
    this._dom.panel.timer.root.style['animation'] = this.duration + 's linear 1s toast-timer-animation forwards';
  };

  /**
   * track initial touch location on toast
   * @param  {TouchEvent} _event touchstart
   */


  Toast.prototype._touchStart = function _touchStart(_event) {
    if (_event) {
      _event.stopImmediatePropagation();
    }
    this._toastRect = this._dom.toast.getBoundingClientRect();
    this._startX = _event.changedTouches[0].screenX;
    this._startY = _event.changedTouches[0].screenY;
  };

  /**
   * track touch end to test if it
   * @param  {TouchEvent} _event touchend
   */


  Toast.prototype._touchEnd = function _touchEnd(_event) {
    var ratio_horizontal = (_event.changedTouches[0].screenX - this._startX) / this._toastRect.width;
    var ratio_vertical = (_event.changedTouches[0].screenY - this._startY) / this._toastRect.height;
    if (ratio_horizontal > ratio_vertical && ratio_horizontal > 0.25) {
      return 'swipe-right';
    }
    if (ratio_vertical > ratio_horizontal && ratio_vertical > 0.25) {
      return 'swipe-down';
    }
    if (ratio_horizontal < ratio_vertical && ratio_horizontal < -0.25) {
      return 'swipe-left';
    }
    if (ratio_vertical < ratio_horizontal && ratio_vertical < -0.25) {

      // trigger close event;
      this._doActionBound(_event);
      return 'swipe-up';
    }
  };

  /**
   * open can be called with values from initial toast creation or called with new values.
   * this will update the toast values, or set them to the defaults if they are omitted from the open call
   * @param  {Object} [options={}] Toast options object
   */


  Toast.prototype._updateValues = function _updateValues() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    // nothing to do options would have been set on creation
    if (Object.keys(options).length === 0) {
      return;
    }
    this.title = options.title || this.defaults.title;
    this.details = options.details || this.defaults.details;
    this.duration = options.duration || this.defaults.duration;
    this.type = options.type || this.defaults.type;
    this.icon = options.icon || this.defaults.icon;
    this.actionIcon = options.actionIcon || this.defaults.actionIcon;
    this.actionLabel = options.actionLabel || this.defaults.actionLabel;
    this.onAction = options.onAction || this.defaults.onAction;
  };

  return Toast;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


Toast.prototype._whitelistedParams = ['elHeader', 'type', 'title', 'details', 'duration', 'icon', 'actionIcon', 'actionLabel', 'onAction'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
Toast.prototype.defaults = {
  el: null,
  elHeader: null,
  type: 'positive',
  title: '',
  details: '',
  icon: '',
  duration: 3,
  actionIcon: '',
  actionLabel: '',
  onAction: null
};

exports.default = Toast;
module.exports = exports['default'];
//# sourceMappingURL=toast.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/toast.js
// module id = 862
// module chunks = 0